
export type AttachmentValidationMode = 
    'full' |
    'file' | 
    'name' |
    'url';

const checkMode = (mode: AttachmentValidationMode, requested: AttachmentValidationMode) => {
    return mode === 'full' || mode === requested;
};

export { checkMode };